import { EmptyState } from '../../components';
import { useI18n } from '../../lib/i18n';
import { Link } from '../../lib/router';

export function NotFound() {
  const { t } = useI18n();
  return (
    <EmptyState
      icon="search"
      title={t('ui.common.notFound')}
      action={
        <Link to="/" className="font-semibold text-brand underline">
          {t('ui.nav.home')}
        </Link>
      }
    />
  );
}
